import React from 'react';

const MerancangGameScratch: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p>
        Di tengah pesatnya perkembangan dunia teknologi dan kecerdasan buatan, keterampilan literasi digital telah menjadi salah satu kompetensi dasar abad ke-21 yang perlu diperkenalkan sejak usia dini. Namun, mengenalkan bahasa pemrograman berbasis teks konvensional sering kali dihadapkan pada hambatan sintaks yang rumit, penulisan tanda baca yang kaku, serta pesan kesalahan yang membingungkan bagi anak-anak. Di sinilah{" "}
        <a
          href="https://scratch.mit.edu/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Scratch
        </a>
        , platform pemrograman visual berbasis blok yang dikembangkan oleh MIT Media Lab, hadir sebagai media pembelajaran interaktif yang ramah anak dan menyenangkan.
      </p>

      <p>
        Mengajak anak-anak merancang dan membangun video game buatan mereka sendiri mengubah posisi mereka dari sekadar konsumen pasif menjadi kreator digital yang aktif. Proses merancang mekanisme permainan menuntut siswa untuk memikirkan aturan main, pergerakan karakter utama, rintangan dinamis, hingga penentuan kondisi menang atau kalah secara terstruktur. Dengan menyusun blok warna-warni seperti balok lego, anak-anak dapat memahami alur komputasi tanpa beban sintaks teks.
      </p>

      <p>
        Dalam kompetisi{" "}
        <span className="font-semibold">Scratch Coding Game</span> yang diselenggarakan dalam ekosistem{" "}
        <span className="font-semibold">Indonesia Innovative Technology (IIT)</span>, peserta diajak merangkai empat pilar utama pembuatan game. Tahapan tersebut dimulai dari pemilihan karakter (sprite) dan latar panggung (backdrop), penyusunan kendali pergerakan responsif melalui blok Events dan Motion, penerapan logika deteksi tabrakan (collision detection) dengan blok Sensing, hingga pembuatan variabel dinamis untuk menghitung perolehan skor pemain.
      </p>

      <p>
        Pendekatan visual ini terbukti efektif dalam memupuk kepercayaan diri anak saat berinteraksi dengan teknologi komputer. Anak-anak belajar bahwa setiap kesalahan atau bug dalam program bukanlah kegagalan, melainkan teka-teki logika yang dapat dianalisis dan diperbaiki secara bertahap melalui proses uji coba langsung di layar panggung animasi Scratch.
      </p>

      <p>
        Fondasi logika pemrograman seperti perulangan (loops), percabangan kondisi (if-else), dan modularitas skrip yang dipelajari selama proses merancang game di Scratch menjadi bekal berharga bagi siswa sebelum melangkah ke jenjang pemrograman profesional di masa mendatang. Pengalaman kreatif ini membuktikan bahwa belajar teknologi dapat berlangsung secara inklusif, mendidik, dan penuh imajinasi.
      </p>
    </div>
  );
};

export default MerancangGameScratch;
